import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { Table, PageHeader, Button } from "antd";
import { reverse } from "named-urls";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { sliceKey, reducer, actions } from "./slice";
import { companyCatalogEditSaga } from "./saga";
import * as selectors from "./selectors";
import routes from "../../../../../routes";

const CompanyCatalog = () => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: companyCatalogEditSaga });
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    dispatch(actions.fetchCompanyDetails({ id: companyId }));
    dispatch(actions.fetchCatalog({ id: companyId, query: `page=1&limit=10` }));
    dispatch(actions.fetchCommodityCategories());
    dispatch(actions.fetchCommodity());
    dispatch(actions.fetchTestCategory());
  }, [dispatch, companyId]);

  const companyDetails = useSelector(selectors.selectCompanyDetails);
  const catalog = useSelector(selectors.selectCatalog);
  const loading = useSelector(selectors.selectLoading);
  // const categories = useSelector(selectors.selectCommodityCategories) || [];
  // const commodities = useSelector(selectors.selectCommodities) || [];
  // const testCategories = useSelector(selectors.selectTestCategories) || [];
  const totalTests = useSelector(selectors.selectTestCount);

  const tableData = catalog.map((entry) => {
    const test = entry.test || {};
    return {
      key: entry._id,
      category: test.commodityCategory?.name,
      commodity: test.commodity?.name,
      testCategory: test.testCategory?.name,
      currency: entry.currency,
      price: entry.price,
      parameter: test.parameter,
    };
  });

  // const getCommodityCategoryFilters = () => {
  //   if (!categories?.length) return [];
  //   const filter = categories.map((cat) => ({
  //     text: cat.name,
  //     value: cat._id,
  //   }));
  //   return filter;
  // };

  // const getCommodityFilters = () => {
  //   if (!commodities?.length) return [];
  //   const filter = commodities.map((cat) => ({
  //     text: cat.name,
  //     value: cat._id,
  //   }));
  //   return filter;
  // };

  // const getTestCategoryFilters = () => {
  //   if (!testCategories?.length) return [];
  //   const filter = testCategories.map((cat) => ({
  //     text: cat.name,
  //     value: cat._id,
  //   }));
  //   return filter;
  // };

  const handleBack = () => {
    history.goBack();
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      // filters: getCommodityCategoryFilters(),
      // filterMode: "menu",
      // filterSearch: true,
      width: "20%",
    },
    {
      title: "Commodity",
      dataIndex: "commodity",
      key: "commodity",
      // filters: getCommodityFilters(),
      // filterMode: "menu",
      // filterSearch: true,
      width: "20%",
    },
    {
      title: "Test Type",
      dataIndex: "testCategory",
      key: "testCategory",
      // filters: getTestCategoryFilters(),
      // filterMode: "menu",
      // filterSearch: true,
      width: "20%",
    },
    {
      title: "Parameter",
      dataIndex: "parameter",
      key: "parameter",
      width: "20%",
    },
    {
      title: "Price",
      dataIndex: "price",
      editable: true,
      key: "price",
      width: "20%",
      render: (value, record) => `${record.currency?.value} ${record.price}`,
    },
  ];

  const handleTablePagination = (pagination, filters, sorter) => {
    setCurrentPage(pagination.current);
    let query = `page=${pagination.current}&limit=10`;
    if (filters.category) {
      filters.category.forEach((cat) => {
        query += `&commodityCategory=${cat}`;
      });
    }
    if (filters.commodity) {
      filters.commodity.forEach((el) => {
        query += `&commodity=${el}`;
      });
    }
    if (filters.testCategory) {
      filters.testCategory.forEach((el) => {
        query += `&testCategory=${el}`;
      });
    }
    dispatch(
      actions.fetchCatalog({
        id: companyId,
        query,
      })
    );
  };

  return (
    <div style={{ height: "100%" }}>
      <PageHeader
        onBack={handleBack}
        ghost={false}
        title="Edit Company Catalog"
        subTitle={companyDetails?.companyName}
        extra={[
          <Button key="1" type="primary">
            <Link
              to={reverse(routes.backOffice.companies.details.catalog.add, {
                companyId,
              })}
            >
              Add More Tests
            </Link>
          </Button>,
        ]}
      />
      <div
        style={{
          height: "calc(100vh - 137px)",
          overflowY: "auto",
          padding: 24,
        }}
      >
        <Table
          columns={columns}
          dataSource={tableData}
          loading={loading}
          pagination={{
            current: currentPage,
            pageSize: 10,
            total: totalTests,
            showSizeChanger: false,
            disabled: tableData.length === 0 ? true : false,
          }}
          onChange={handleTablePagination}
        />
      </div>
    </div>
  );
};

export default CompanyCatalog;
